import { render } from "./PackageCreation.vue?vue&type=template&id=5ae20796&scoped=true"
import script from "./PackageCreation.vue?vue&type=script&lang=js"
export * from "./PackageCreation.vue?vue&type=script&lang=js"

import "./PackageCreation.vue?vue&type=style&index=0&id=5ae20796&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae20796"]])

export default __exports__